import Store from '@/store';
import SLSItemsClient from '@/api/sls-items.client';
import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';

export default class SLSItemService {
  constructor() {
    this.client = new SLSItemsClient();
    this.notify = new Notifier();
    this.store = Store;
  }

  async findAll(queries = { fullObject: false }) {
    try {
      if (queries.fullObject) {
        return await this.client.getItems(queries);
      }
      const { data } = await this.client.getItems(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async createItem(item) {
    try {
      const response = await this.client.createItem(item);
      return response;
    } catch (error) {
      const errorMessage = error.message || 'Erro desconhecido ao criar Produto';
      console.error('Erro ao criar item:', errorMessage);
      throw error;
    }
  }

  async updateItem(id, data) {
    try {
      const response = await this.client.updateItem(id, data);
      return response;
    } catch (error) {
      const errorMessage = error.message || 'Erro desconhecido ao alterar Produto';
      console.error('Erro ao alterar item:', errorMessage);
      throw error;
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Produto');
    }
  }

  async getItemDescribe() {
    try {
      return await this.client.getItemDescribe();
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async getItemById(id) {
    try {
      return await this.client.getItemById(id);
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async getInfoItemByCodCategEndCodMarca(data) {
    try {
      return await this.client.getInfoItemByCodCategEndCodMarca(data);
    } catch (error) {
      return error;
    }
  }
}
